import React from 'react'
import { CarouselHero } from '~shared/components/carousel-hero'
import { ProgramCategories } from '../../../features/program-categories/program-category'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Button } from '~shared/components/button-v2'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'
import { getStoriesData } from '@/modules/home-page/widgets/Hero/fractals/api/getStoriesData'

type Props = {
  stories: Awaited<ReturnType<typeof getStoriesData>>
  categories: Awaited<ReturnType<typeof getCategoriesData>>
}

export const Hero: React.FC<Props> = ({ stories, categories }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <section className='container container-slim'>
      <div className='relative md:p-[24px] lg:p-[40px] xl:p-[60px] min-h-[625px] 2xl:min-h-[744px] md:flex flex-col'>
        <div className=''>
          <h1 className='typo-section-heading md:text-white max-w-[800px] mb-[16px] md:mb-[24px] mt-0 2xl:text-[80px] 2xl:max-w-[1000px]'>
            Самый инновационный ВУЗ страны
          </h1>
          <p className='md:text-white mb-[30px] md:mb-0'>
            Получи образование дистанционно
          </p>
        </div>
        <CarouselHero stories={stories} />
        <div className=''>
          <Button
            size='slg'
            variant='primary'
            onClick={() => setIsOpen(true)}
            className='px-[80px] w-full mt-[10px] mb-[30px]
            md:my-[40px] md:w-fit 2xl:h-[100px] 2xl:text-[24px] 2xl:mt-[60px] 2xl:mb-[80px]'>
            Записаться на курс
          </Button>
          <LeadFormDialog open={isOpen} onOpenChange={setIsOpen} />
          <ProgramCategories categories={categories} />
        </div>
      </div>
    </section>
  )
}
